// White-label agency branding, stored per browser so each partner keeps their own.
const KEY = "wf_agency";

export const getAgency = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
};

export const setAgency = (a) => localStorage.setItem(KEY, JSON.stringify(a || {}));

export const hasBranding = () => {
  const a = getAgency();
  return !!(a && (a.name || a.logo));
};
